import { Component } from '@angular/core';

@Component({
  selector: 'home-exclusive-card',
  standalone: false,
  templateUrl: './exclusive-card.component.html',
  styleUrl: './exclusive-card.component.css'
})
export class ExclusiveCardComponent {

}
